// Direct Manager Discrepancy Audit — mismatch reason badge configs (ADR-010 Phase 6).
//
// Lists only the *populated* DiscrepancyMismatchReasonEnum values for this phase.
// EXPECTED_BU_FALLBACK is reserved in the schema but not populated until the
// next-phase work activates classification (Open Question 3 — deferred). The
// future-phase author adds its entry here at the same time as the matcher change.

export const DISCREPANCY_MISMATCH_REASONS = {
  DIFFERENT_PERSON:    'DIFFERENT_PERSON',
  EMAIL_MISMATCH_ONLY: 'EMAIL_MISMATCH_ONLY',
  NAME_ONLY_DIFF:      'NAME_ONLY_DIFF',
  REPORTED_MISSING:    'REPORTED_MISSING',
  RADAR_MISSING:       'RADAR_MISSING',
};

export const DISCREPANCY_MISMATCH_REASON_LABELS = {
  [DISCREPANCY_MISMATCH_REASONS.DIFFERENT_PERSON]:    'Different person',
  [DISCREPANCY_MISMATCH_REASONS.EMAIL_MISMATCH_ONLY]: 'Email mismatch',
  [DISCREPANCY_MISMATCH_REASONS.NAME_ONLY_DIFF]:      'Name only differs',
  [DISCREPANCY_MISMATCH_REASONS.REPORTED_MISSING]:    'Reported missing',
  [DISCREPANCY_MISMATCH_REASONS.RADAR_MISSING]:       'Radar missing',
};

// MUI Chip color values — mapped to the closest existing badge convention.
export const DISCREPANCY_MISMATCH_REASON_COLORS = {
  [DISCREPANCY_MISMATCH_REASONS.DIFFERENT_PERSON]:    'error',
  [DISCREPANCY_MISMATCH_REASONS.EMAIL_MISMATCH_ONLY]: 'warning',
  [DISCREPANCY_MISMATCH_REASONS.NAME_ONLY_DIFF]:      'info',
  [DISCREPANCY_MISMATCH_REASONS.REPORTED_MISSING]:    'warning',
  [DISCREPANCY_MISMATCH_REASONS.RADAR_MISSING]:       'warning',
};

export const DISCREPANCY_MISMATCH_REASON_OPTIONS = Object.values(DISCREPANCY_MISMATCH_REASONS).map((value) => ({
  value,
  label: DISCREPANCY_MISMATCH_REASON_LABELS[value],
}));
